import {makeStyles} from '@material-ui/core';

export default makeStyles(() => (
    {
        root: {
            flexGrow: 1
        },
        list: {
            width: 150
        }
    }
))